import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from '@/context/AuthContext';
import { Navbar } from '@/components/Navbar';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import { ImpersonationBanner } from '@/components/ImpersonationBanner';
import { Toaster } from '@/components/ui/sonner';

import Landing from '@/pages/Landing';
import Login from '@/pages/Login';
import Register from '@/pages/Register';
import ForgotPassword from '@/pages/ForgotPassword';
import ResetPassword from '@/pages/ResetPassword';
import Onboarding from '@/pages/Onboarding';
import Upload from '@/pages/Upload';
import AnalysisResult from '@/pages/AnalysisResult';
import Dashboard from '@/pages/Dashboard';
import Goals from '@/pages/Goals';
import Challenges from '@/pages/Challenges';
import Leaderboard from '@/pages/Leaderboard';
import Spots from '@/pages/Spots';
import SpotDetail from '@/pages/SpotDetail';
import SessionLog from '@/pages/SessionLog';
import Pricing from '@/pages/Pricing';
import SharePage from '@/pages/SharePage';
import CoachChat from '@/pages/CoachChat';
import GearAdvisor from '@/pages/GearAdvisor';
import Referrals from '@/pages/Referrals';
import BillingReturn from '@/pages/BillingReturn';
import Profile from '@/pages/Profile';
import Admin from '@/pages/Admin';
import AdminUserDetail from '@/pages/AdminUserDetail';
import AdminGrowthPlan from '@/pages/AdminGrowthPlan';
import Compare from '@/pages/Compare';
import ExampleAnalysis from '@/pages/ExampleAnalysis';
import CoachPage from '@/pages/CoachPage';
import { AdminRoute } from '@/components/AdminRoute';
import { FeedbackWidget } from '@/components/FeedbackWidget';
import { PageTracker } from '@/components/PageTracker';

function App() {
  return (
    <div className="App min-h-screen bg-[#0A0A0A]">
      <BrowserRouter>
        <AuthProvider>
          <PageTracker />
          <ImpersonationBanner />
          <Navbar />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/spots" element={<Spots />} />
            <Route path="/spots/:id" element={<SpotDetail />} />
            <Route path="/kaia" element={<CoachPage />} />
            <Route path="/meet-kaia" element={<CoachPage />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/voorbeeld-analyse" element={<ExampleAnalysis />} />
            <Route path="/example-analysis" element={<ExampleAnalysis />} />
            <Route path="/share/:token" element={<SharePage />} />
            <Route path="/onboarding" element={<ProtectedRoute><Onboarding /></ProtectedRoute>} />
            <Route path="/analyze" element={<ProtectedRoute><Upload /></ProtectedRoute>} />
            <Route path="/analysis/:id" element={<ProtectedRoute><AnalysisResult /></ProtectedRoute>} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/goals" element={<ProtectedRoute><Goals /></ProtectedRoute>} />
            <Route path="/challenges" element={<ProtectedRoute><Challenges /></ProtectedRoute>} />
            <Route path="/leaderboard" element={<ProtectedRoute><Leaderboard /></ProtectedRoute>} />
            <Route path="/sessions" element={<ProtectedRoute><SessionLog /></ProtectedRoute>} />
            <Route path="/referrals" element={<ProtectedRoute><Referrals /></ProtectedRoute>} />
            <Route path="/compare" element={<ProtectedRoute><Compare /></ProtectedRoute>} />
            <Route path="/gear-advisor" element={<GearAdvisor />} />
            <Route path="/billing/return" element={<ProtectedRoute><BillingReturn /></ProtectedRoute>} />
            <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
            <Route path="/admin" element={<AdminRoute><Admin /></AdminRoute>} />
            <Route path="/admin/growth-plan" element={<AdminRoute><AdminGrowthPlan /></AdminRoute>} />
            <Route path="/admin/users/:id" element={<AdminRoute><AdminUserDetail /></AdminRoute>} />
            <Route path="/coach" element={<ProtectedRoute><CoachChat /></ProtectedRoute>} />
            <Route path="/coach/:analysisId" element={<ProtectedRoute><CoachChat /></ProtectedRoute>} />
          </Routes>
          <FeedbackWidget />
          <Toaster position="top-center" theme="dark" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
